// @flow

import React from "react";
import cx from "classnames";
import sumBy from "lodash/sumBy";

import { ratioToPercentage } from "../../utils/unitConversions";

import StepPanel from "./StepPanel";
import styles from "./ProgressBar.scss";

export type StepState = {|
  id: string,
  outOf: number,
  title: string,
  valid: number
|};

type ProgressBarProps = {
  activeStepId: string,
  steps: StepState[]
};

const ProgressBar = ({ activeStepId, steps }: ProgressBarProps) => (
  <div className={styles.wrapper}>
    <div className={styles.stepsWrapper}>
      {steps.map(step => (
        <div className={styles.stepWrapper} key={step.id}>
          <StepPanel
            isActive={activeStepId === step.id}
            isCompleted={
              steps.findIndex(s => s.id === step.id) < steps.findIndex(s => s.id === activeStepId)
            }
            outOf={step.outOf}
            stepCount={steps.length}
            title={step.title}
            valid={step.valid}
          />
        </div>
      ))}
    </div>
    <div className={styles.barBackground}>
      <div
        className={cx(styles.bar, styles.totalProgressBar)}
        style={{
          width: ratioToPercentage(
            sumBy(steps, (step: StepState) => step.valid),
            sumBy(steps, (step: StepState) => step.outOf)
          )
        }}
      />
    </div>
  </div>
);

export default ProgressBar;
